import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient instance.
 *
 * Exported from a standalone module (instead of being created inline in
 * index.tsx) so non-React modules — e.g. the WebSocket service — can
 * invalidate queries when real-time events arrive.
 */
const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: twentyFourHoursInMs,
    },
  },
});
